/**
 * The upload ceiling, restated for the browser.
 *
 * The server's `MAX_UPLOAD_BYTES` lives in `apps/api/src/lib/storage.ts`, which is server-only
 * (it pulls in object storage) and cannot be imported here. Checking the size client-side is
 * purely a courtesy — the server rejects an oversized file regardless, and it is the only check
 * that counts — but without it a person on a phone connection uploads 40 MB before being told no.
 */

export const MAX_UPLOAD_BYTES_CLIENT = 10 * 1024 * 1024;

export type { ParseDocumentBody } from '@hrms/shared';
